import React, {Component} from 'react';
import DefaultModal from "../../invoice/DefaultModal";
import {Col, Row} from "reactstrap";
import ExternalCustomerGeneralInfo from "../../externalcustomer/components/ExternalCustomerGeneralInfo";
import ExternalCustomerAddressInfo from "../../externalcustomer/components/ExternalCustomerAddressInfo";
import ExternalCustomerBankInfo from "../../externalcustomer/components/ExternalCustomerBankInfo";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import ForeignCompanyGeneralInfo from "../../externalcustomer/components/ForeignCompanyGeneralInfo";
import NotifyKS from "../../../components/NotifyKS";
import Swal from "sweetalert2";

class ExternalCustomerModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: {},
			selectedAddressIndex: -1,
			customerType: 2,
			editAddressMode: 'passive',
			externalCustomerBank: {
				recordId: '',
				bankName: '',
				iban: ''
			},
			externalCustomerAddress: {
				recordId: null,
				addressName: '',
				gbAlias: '',
				pkAlias: '',
				countryName: 'Türkiye',
				cityName: '',
				citySubdivisionName: '',
				webSite: '',
				email: '',
				telephone: '',
				fax: '',
				postalAddressRegion: '',
				streetName: '',
				buildingName: '',
				postalAddressRoom: '',
				postalZone: '',
				contactPerson: '',
				manualInput: null,
				notify: null
			}
		};
		this.defineTabName = this.defineTabName.bind(this);
		this.onChangeExternalCustomer = this.onChangeExternalCustomer.bind(this);
		this.onChangeExternalCustomerAddress = this.onChangeExternalCustomerAddress.bind(this);
		this.onCityChange = this.onCityChange.bind(this);
		this.onCountryChange= this.onCountryChange.bind(this);
		this.onCitySubdivisionChange = this.onCitySubdivisionChange.bind(this);
		this.onChangeExternalCustomerBank = this.onChangeExternalCustomerBank.bind(this);
		this.getSubdivisionsForCity = this.getSubdivisionsForCity.bind(this);
		this.toggle = this.toggle.bind(this);
		this.addAddressToCustomer = this.addAddressToCustomer.bind(this);
		this.addBankToCustomer = this.addBankToCustomer.bind(this);
		this.clearExternalCustomerAddress = this.clearExternalCustomerAddress.bind(this);
		this.clearExternalCustomerBank = this.clearExternalCustomerBank.bind(this);
		this.fillAddressForm = this.fillAddressForm.bind(this);
		this.fillBankForm = this.fillBankForm.bind(this);
		this.isChanged = this.isChanged.bind(this);
		this.deleteAddressFromExternalCustomer = this.deleteAddressFromExternalCustomer.bind(this);
		this.deleteBankFromExternalCustomer = this.deleteBankFromExternalCustomer.bind(this);
		this.onChangeType = this.onChangeType.bind(this);
		this.onChangeRiskLimitOrBalance = this.onChangeRiskLimitOrBalance.bind(this);
		this.checkBeforeSubmit = this.checkBeforeSubmit.bind(this);
		this.selectedAddress = this.selectedAddress.bind(this);
		this.editAddress = this.editAddress.bind(this);
		this.addNewBank = this.addNewBank.bind(this);
		this.setPkAlias = this.setPkAlias.bind(this);
		this.selectedAddressChange = this.selectedAddressChange.bind(this);
	}

	componentWillMount() {
		let externalCustomer = this.props.externalCustomer;
		let externalCustomerAddress = this.props.externalCustomerAddress || this.clearExternalCustomerAddress();
        externalCustomer["externalCustomerMainType"] = this.props.externalCustomerMainType;

        this.setState({
			externalCustomer: externalCustomer,
			externalCustomerAddress: externalCustomerAddress,
			externalCustomerAddressList: externalCustomer.externalCustomerAddressList || [],
			externalCustomerBankList: externalCustomer.externalCustomerBankList || [],
			activeTab: this.props.activeTab || '1',
		});
	}

	clearExternalCustomerAddress() {
		let externalCustomerAddress = {
			recordId: null,
			addressName: '',
			gbAlias: '',
			pkAlias: '',
			countryName: 'Türkiye',
			cityName: '',
			citySubdivisionName: '',
			webSite: '',
			email: '',
			telephone: '',
			fax: '',
			postalAddressRegion: '',
			streetName: '',
			buildingName: '',
			postalAddressRoom: '',
			postalZone: '',
			contactPerson: '',
			manualInput: null
		};
		this.setState({
			externalCustomerAddress,
			editAddressMode: 'passive'
		})
	}

	onChangeExternalCustomerAddress(e) {
		if(e.target.name === "email") e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
		if (e.target && e.target.name && e.target.value && e.target.name === "postalZone" && isNaN(e.target.value)) {
		} else {
			this.setState({
				externalCustomerAddress: {
					...this.state.externalCustomerAddress,
					[e.target.name]: e.target.value
				}
			});
		}
	}

	setPkAlias(type, alias) {
		this.setState({
			externalCustomerAddress: {
				...this.state.externalCustomerAddress,
				[type]: alias
			}
		})
	}

	deleteAddressFromExternalCustomer(data) {
		let self = this;
		let error = {};
		let addressValidity = this.addressInfoChild.validateComponent();
		let addressInfoError = this.addressInfoChild.state.error;
		for (let key in addressInfoError) {
			error[key] = addressInfoError[key]
		}

		this.setState({
			error
		}, function () {
			if (addressValidity.valid && !(this.state.externalCustomer.externalCustomerAddressList === null ||
				self.state.externalCustomer.externalCustomerAddressList.length === 1)) {

				let recordId = JSON.parse(JSON.stringify(data));
				let params = {
					url: '/externalCustomer/deleteAddress/'+ recordId,
					method: 'post'
				};
				request(params).then(() => {
					Swal({
						title: 'Başarılı ! ',
						text: ("Silme işlemi başarıyla gerçekleştirildi."),
						type: 'success',
						confirmButtonText: 'Tamam'
					});
					let externalCustomerAddressList = deepCopyObject(self.state.externalCustomerAddressList);
					externalCustomerAddressList.splice(externalCustomerAddressList.findIndex(eca => eca.recordId === data),1);
					self.setState({
						externalCustomerAddressList,
						externalCustomer: {
							...this.state.externalCustomer,
							externalCustomerAddressList
						}
					}, () => this.clearExternalCustomerAddress())


				}).catch(function (error) {
					showAxiosError(error);
				});

			} else {
				Alert.error("Carinin en az bir adresi olmalıdır.", {
					html: true,
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		});
	}

	isChanged(initState, input) {
		if (this.state.mode === 'create') {
			return false
		} else {
			if (initState === JSON.stringify(input)) {
				return false
			} else {
				return true
			}
		}
	}

	addAddressToCustomer() {
		let result = this.addressInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let externalCustomerAddressList = deepCopyObject(this.state.externalCustomerAddressList);

				let found = false;
				externalCustomerAddressList.map(eca => {
					if (eca.addressName === this.state.externalCustomerAddress.addressName) {
						found = true;
					}
				});

				if (!found) {
					externalCustomerAddressList.push(this.state.externalCustomerAddress);

					this.setState({
						externalCustomerAddressList,
						externalCustomer: {
							...this.state.externalCustomer,
							externalCustomerAddressList
						}
					}, () => this.clearExternalCustomerAddress(), this.addressInfoChild.closeAddAddressModal())
				} else {
					Alert.error('Aynı adlı adres kaydı zaten mevcut.', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					})
				}
			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		})
	}

	fillAddressForm(data) {
		this.setState({
			editAddressMode: data.editAddressMode,
			selectedAddressIndex: data.index,
			externalCustomerAddress: data.row
		})
	}

	onChangeExternalCustomer(e) {
		let externalCustomer = deepCopyObject(this.state.externalCustomer);
		externalCustomer[e.target.name] = e.target.value;
		if (e.target.name === "title") {
			this.setState({externalCustomer: externalCustomer, currentTitle: e.target.value});
		} else if(e.target.name=== "formattedName"){
			e.target.value = e.target.value.replace(/ +(?= )/g,'');
			externalCustomer[e.target.name] = e.target.value;
		}
		this.setState({externalCustomer: externalCustomer});

	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			})
		}
	}

	defineTabName() {
		if (this.state.activeTab === '1') {
			return 'Adres Bilgileri'
		} else {
			return 'Banka Bilgileri'
		}
	}

	// ADDRESS OPERATIONS - START
	onCityChange(e) {
		this.setState({
			externalCustomerAddress: {
				...this.state.externalCustomerAddress,
				cityName: e.value
			}
		})
	}

	onCitySubdivisionChange(e) {
		this.setState({
			externalCustomerAddress: {
				...this.state.externalCustomerAddress,
				citySubdivisionName: e.value
			}
		})
	}

    onCountryChange(e) {
        this.setState({
            externalCustomerAddress: {
                ...this.state.externalCustomerAddress,
                countryName: e.value
            }
        })
    }

	getSubdivisionsForCity(data) {
		if (data === null) {
			return [];
		}

		if (this.state.externalCustomerAddress.cityName) {
			let cityList = this.props.cities.find(obj => obj.cityName === data);
			if (cityList) {
				return cityList.subdivisions.map(subdiv => ({
					value: subdiv.name,
					label: subdiv.name
				}));
			} else {
				return [];
			}
		}
	}

	onChangeType(e) {
		let externalCustomer = this.state.externalCustomer;
		if (this.state.customerType === 1 || this.state.customerType === 2) {
			externalCustomer[e.target.name] = 3;
			this.setState({externalCustomer: externalCustomer, customerType: 3});
		} else {
			externalCustomer[e.target.name] = 2;
			this.setState({externalCustomer: externalCustomer, customerType: 2});
		}
	}

	onChangeRiskLimitOrBalance(e) {
		let externalCustomer = this.state.externalCustomer;
		externalCustomer[e.name] = e.value;
		this.setState({externalCustomer});
	}

	// BANK OPERATIONS - START
	onChangeExternalCustomerBank(e) {
		this.setState({
			externalCustomerBank: {
				...this.state.externalCustomerBank,
				[e.target.name]: e.target.value
			}
		})
	}

	clearExternalCustomerBank() {
		let externalCustomerBank = {
			recordId: '',
			bankName: '',
			iban: ''
		};
		this.setState({
			externalCustomerBank
		})
	}

	async addBankToCustomer() {
		await this.addNewBank();
		let result = this.bankInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let externalCustomerBankList = deepCopyObject(this.state.externalCustomerBankList);
				externalCustomerBankList.push(this.state.externalCustomerBank);

				this.setState({
					externalCustomerBankList,
					externalCustomer: {
						...this.state.externalCustomer,
						externalCustomerBankList
					}
				}, () => this.clearExternalCustomerBank())
			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		})
	}


	selectedAddressChange(){
		let address = deepCopyObject(this.state.externalCustomerAddress)
		if (address.defaultAddress === true){
			address.defaultAddress = false;
			this.setState({externalCustomerAddress: address})
		}else {
			address.defaultAddress = true;
			this.setState({externalCustomerAddress: address})
		}
	}

	deleteBankFromExternalCustomer(id, index) {
		let recordId = JSON.parse(JSON.stringify(id));
		if (recordId === "") {
			let externalCustomerBankList = deepCopyObject(this.state.externalCustomerBankList);
			externalCustomerBankList.splice(index, 1);
			this.setState({
				externalCustomerBankList: externalCustomerBankList,
				externalCustomer: {
					...this.state.externalCustomer,
					externalCustomerBankList: externalCustomerBankList
				}
			})
		} else {
			let params = {
				url: '/externalCustomer/deleteBank/',
				data: recordId,
				method: 'delete'
			};
			request(params).then(() => {
				Alert.success('Silme işlemi başarıyla gerçekleştirildi.', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
			}).catch(function (error) {
				showAxiosError(error);
			});
		}
	}

	fillBankForm(data) {
		this.setState({
			externalCustomerBank: data,
		})
	}

	// BANK OPERATIONS - END

	checkBeforeSubmit() {
		let error = {};
		let generalValidity = this.generalInfoChild.validateComponent();
		let generalInfoError = this.generalInfoChild.state.error;
		for (let key in generalInfoError) {
			error[key] = generalInfoError[key]
		}

		let addressValidity = this.addressInfoChild.validateComponent();
		let addressInfoError = this.addressInfoChild.state.error;
		for (let key in addressInfoError) {
			error[key] = addressInfoError[key]
		}

		let bankValidity = this.bankInfoChild.validateComponent();
		let bankInfoError = this.bankInfoChild.state.error;
		for (let key in bankInfoError) {
			error[key] = bankInfoError[key]
		}

		this.setState({
			error
		}, function () {
			if ((generalValidity.valid && addressValidity.valid && bankValidity.valid) && !(this.state.externalCustomer.externalCustomerAddressList === null ||
					this.state.externalCustomer.externalCustomerAddressList.length === 0)) {
				this.handleSubmit();
			} else {
				Alert.error(this.arrangeErrorMessage(), {
					html: true,
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		});
	}

	arrangeErrorMessage() {
		let errorObject = deepCopyObject(this.state.error);

		let errorArray = [];

		if (this.state.externalCustomer.externalCustomerAddressList === null || this.state.externalCustomer.externalCustomerAddressList.length === 0) {
			let error = {};
			error.field = '*';
			error.message = 'En Az Bir Adres Belirtilmeden Cari Kaydedilemez';
			errorArray.push(error)
		}

		for (let key in errorObject) {
			if (errorObject.hasOwnProperty(key)) {
				let error = {};
				if (!!errorObject[key].message && key !== 'tCity') {
					error.field = this.defineReadableFieldName(key);
					error.message = errorObject[key].message;
					errorArray.push(error);
				}
			}
		}

		this.setState({error: errorObject});

		return errorArray.map(error => '<strong>' + error.field + error.message + '</strong><br/><br/>').join('')
	}

	defineReadableFieldName(key) {

		switch (key) {
			case 'tVknTckn':
				return 'Vkn/Tckn ';
			case 'tFormattedName':
				return 'Unvan ';
			case 'tGivenName':
				return 'Adı ';
			case 'tFamilyName':
				return 'Soyadı ';
			case 'tTaxOffice':
				return 'Vergi Dairesi ';
			case 'tMiddleName':
				return 'Orta Adı ';
			default :
				return '';
		}
	}

	handleSubmit() {
		let self = this;
		const data = self.state.externalCustomer;
		data.customerType = this.state.customerType;

		let params = {
			url: `/externalCustomer/create`,
			data: data,
			method: 'post'
		};
		request(params)
			.then((request) => {
				let externalCustomer = request.data;
				let externalCustomerAddress = this.state.selectedAddressIndex === -1 ? externalCustomer.externalCustomerAddressList.filter((f) => f.defaultAddress === true)[0] : externalCustomer.externalCustomerAddressList[this.state.selectedAddressIndex]
				self.props.listener(externalCustomer, externalCustomerAddress, true, false);
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	selectedAddress(externalCustomerAddress, index) {
		this.setState({externalCustomerAddress: externalCustomerAddress, selectedAddressIndex: index});
		this.props.listener(this.state.externalCustomer, externalCustomerAddress, false, true);
	}

	editAddress() {
		let result = this.addressInfoChild.validateComponent();
		this.setState({
			childValidInfo: result.valid
		}, () => {
			if (this.state.childValidInfo === true) {
				let address = deepCopyObject(this.state.externalCustomerAddress);
				let externalCustomerAddressList = deepCopyObject(this.state.externalCustomerAddressList);
				let index = deepCopyObject(this.state.selectedAddressIndex);

				let found = false;
				externalCustomerAddressList.map(eca => {
					if (eca.addressName === address.addressName && eca.recordId !== address.recordId) {
						found = true;
					}
				});

				if (!found) {
					externalCustomerAddressList.splice(index, 1, address);
					this.setState({
						externalCustomerAddressList,
						externalCustomer: {
							...this.state.externalCustomer,
							externalCustomerAddressList
						}
					}, () => this.clearExternalCustomerAddress(), this.addressInfoChild.closeAddAddressModal())
				} else {
					Alert.error('Aynı adlı adres kaydı zaten mevcut.', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					})
				}

			} else {
				Alert.error('Hatalı alanlar mevcut. Lütfen girdiğiniz bilgileri kontrol edin', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		});
	}

	async addNewBank() {
		let self = this;
		let externalCustomerBank = self.state.externalCustomerBank;

		let data = self.state.externalCustomerBank;
		data.externalCustomer = self.state.externalCustomer;
		let params = {
			url: `/externalCustomer/addNewBank`,
			method: 'post',
			data: data
		};
		await request(params)
			.then(function (response) {
				externalCustomerBank.recordId = response.data.recordId;
				self.setState({
					notify: {
						type: 'success',
						message: 'Banka kaydı başarıyla kaydedildi'
					},
					deleteModal: false,
					externalCustomerBank
				})
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	render() {
		return (
			<DefaultModal
				disabled={this.state.sendBtnDisabled}
				isOpen={this.props.modal}
				title={this.props.type === 'suppliers' ? 'Tedarikçi Bilgileri' : this.props.title}
				size={"lg"}
				confirmBtnText="Kaydet"
				cancelBtnText="İptal"
				onConfirm={this.checkBeforeSubmit}
				onCancel={(e) => this.props.listener(this.props.externalCustomer, this.props.externalCustomerAddress, false, false)}>
				<div className="row">
					<div className="col-md-12">
						<div className="FormRenk2">
							{!this.props.showBuyerType &&
							<ExternalCustomerGeneralInfo ref={instance => {
								this.generalInfoChild = instance
							}}
														 size={6}
														 marginTop={-42}
														 showBuyerType={this.props.showBuyerType}
														 externalCustomer={this.state.externalCustomer}
														 onChangeExternalCustomer={this.onChangeExternalCustomer}
														 type={this.props.type}
														 requiredTaxOffice={this.props.requiredTaxOffice}
														 cities={this.props.cities}
														 title={this.props.title}
														 onChangeType={this.onChangeType}
														 customerType={this.state.customerType}
														 onChangeRiskLimitOrBalance={this.onChangeRiskLimitOrBalance}
														 externalCustomerMainType={this.props.externalCustomerMainType}
							/>
							}
							{this.props.showBuyerType &&
							<ForeignCompanyGeneralInfo ref={instance => {
								this.generalInfoChild = instance
							}}
													   size={6}
													   marginTop={-42}
													   showBuyerType={this.props.showBuyerType}
													   externalCustomer={this.state.externalCustomer}
													   onChangeExternalCustomer={this.onChangeExternalCustomer}
													   type={this.props.type}
													   cities={this.props.cities}
													   title={this.props.title}
													   onChangeType={this.onChangeType}
													   customerType={this.state.customerType}
													   onChangeRiskLimitOrBalance={this.onChangeRiskLimitOrBalance}
							/>
							}
						</div>
					</div>

					<div className="col-sm-12">
						<div className="card">
							<div className="card-header">
								<h4 className="card-title"></h4>
							</div>
							<div className="card-body">

								<div className=" card-nav-tabs card-plain">
									<div className="card-header card-header-danger">
										<div className="nav-tabs-navigation">
											<div className="nav-tabs-wrapper">
												<ul className="nav nav-tabs" data-tabs="tabs">
													<li className="nav-item">
														<a className="nav-link active" href="#home" data-toggle="tab">Adres Bilgileri </a>
													</li>
													<li className="nav-item">
														<a className="nav-link" href="#updates" data-toggle="tab">Banka Bilgileri</a>
													</li>
												</ul>
											</div>

											{this.state.notify &&
											<Row>
												<NotifyKS
													type={this.state.notify.type}
													message={this.state.notify.message}
													html={this.state.notify.html}
													timeout={this.state.notify.timeout}
													autohide={this.state.notify.autohide}
												/>
											</Row>}

										</div>
									</div>
									<hr></hr>
									<div className="card-body ">
										<div className="tab-content text-center">
											<div className="tab-pane active" id="home">
												<div>

													<Row>
														<Col sm="12">
															<ExternalCustomerAddressInfo ref={instance => {
																this.addressInfoChild = instance
															}}
																						 manualCity={this.props.showBuyerType}
																						 externalCustomer={this.state.externalCustomer}
																						 onChangeExternalCustomerAddress={this.onChangeExternalCustomerAddress}
																						 onCityChange={(e) => e && this.onCityChange(e)}
																						 onCitySubdivisionChange={this.onCitySubdivisionChange}
																						 getSubdivisionsForCity={this.getSubdivisionsForCity}
																						 currentTitle={this.state.currentTitle}
																						 externalCustomerAddress={this.state.externalCustomerAddress}
																						 selectedAddress={this.selectedAddress}
																						 addAddressToCustomer={this.addAddressToCustomer}
																						 externalCustomerAddressList={this.state.externalCustomerAddressList || []}
																						 editAddressMode={this.state.editAddressMode}
																						 cities={this.props.cities}
																						 fillAddressForm={this.fillAddressForm}
																						 clearForm={this.clearExternalCustomerAddress}
																						 editAddress={this.editAddress}
																						 deleteAddress={this.deleteAddressFromExternalCustomer}
																						 docType={this.props.docType}
																						 countries={this.props.countries}
                                                                                         onCountryChange={this.onCountryChange}
																						 setPkAlias={this.setPkAlias}
																						 isForeign={this.props.showBuyerType}
																						 selectedAddressChange={this.selectedAddressChange}
															/>
														</Col>
													</Row>

												</div>
											</div>
											<div className="tab-pane" id="updates">
												<div>
													<Row>
														<Col sm="12">
															<ExternalCustomerBankInfo ref={instance => {
																this.bankInfoChild = instance
															}}
																					  externalCustomer={this.state.externalCustomer}
																					  currentTitle={this.state.currentTitle}
																					  onChangeExternalCustomerBank={this.onChangeExternalCustomerBank}
																					  externalCustomerBank={this.state.externalCustomerBank}
																					  addBankToCustomer={this.addBankToCustomer}
																					  externalCustomerBankList={this.state.externalCustomerBankList || []}
																					  fillBankForm={this.fillBankForm}
																					  clearForm={this.clearExternalCustomerBank}
																					  deleteBank={this.deleteBankFromExternalCustomer}/>
														</Col>
													</Row>
												</div>
											</div>

										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</DefaultModal>


		);
	}
}

export default ExternalCustomerModal;